const STORAGE_KEY = 'consumed_auth_payload';

/**
 * Дедупликация одноразовых auth-значений: MAX переотправляет старый
 * start_param, а страницу с ?code= могут перезагрузить.
 */
export function isAuthPayloadConsumed(value: string): boolean {
  return localStorage.getItem(STORAGE_KEY) === value;
}

export function markAuthPayloadConsumed(value: string): void {
  localStorage.setItem(STORAGE_KEY, value);
}
